import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(authed)/groups/page.tsx");
